import { create } from 'zustand';

/**
 * Cola de avisos de la aplicación.
 *
 * Los avisos se muestran de uno en uno como modal centrado y solo se cierran
 * cuando la persona pulsa OK. Si llegan varios seguidos (una importación en
 * lote, por ejemplo), se encolan y se ven uno tras otro en vez de amontonarse.
 */
let siguienteId = 1;

export const useNoticeStore = create((set) => ({
    cola: [],

    push: (tipo, mensaje) =>
        set((estado) => ({
            cola: [...estado.cola, { id: siguienteId++, tipo, mensaje }]
        })),

    dismiss: () =>
        set((estado) => ({
            cola: estado.cola.slice(1)
        })),

    clear: () => set({ cola: [] })
}));

export default useNoticeStore;
